import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { UserProvider } from './components/UserContext';
import { MessagingProvider } from './contexts/MessagingContext';
import Home from './components/Home/Home';
import CustomerCatalogues from './components/CustomerCatalogues/CustomerCatalogues';
import BrandPage from './components/BrandPage';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';

// Customer Portal Components
import CustomerAuth from './components/CustomerAuth';
import CustomerLayout from './components/CustomerLayout';
import CustomerDashboard from './components/CustomerDashboard';
import CustomerAccount from './components/CustomerAccount';
import CustomerOrders from './components/CustomerOrders';
import CustomerOrderDetail from './components/CustomerOrderDetail';
import CustomerNewOrder from './components/CustomerNewOrder';
import CustomerCart from './components/CustomerCart';
import CustomerCheckout from './components/CustomerCheckout';
import CustomerOrderConfirmation from './components/CustomerOrderConfirmation';
import CustomerInvoices from './components/CustomerInvoices';
import CustomerPayInvoice from './components/CustomerPayInvoice';
import CustomerProducts from './components/CustomerProducts';
import CustomerBrands from './components/CustomerBrands';
import CustomerBoard from './components/CustomerBoard';
import CustomerSignup from './components/CustomerSignup';
import CustomerOrderView from './components/CustomerOrderView';
import CustomerAmendOrder from './components/CustomerAmendOrder';
import CustomerRequestCatalogue from './components/CustomerRequestCatalogue';
import CustomerSettings from './components/CustomerSettings';

import './App.css';

function App() {
  return (
    <UserProvider>
      <MessagingProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Default route shows homepage */}
              <Route path="/" element={<Home />} />
              
              {/* Public routes */}
              <Route path="/home" element={<Home />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/events" element={<Home />} />
              <Route path="/brand/:brandId" element={<BrandPage />} />
              <Route path="/catalogues" element={<CustomerCatalogues />} />
              <Route path="/customer/catalogues" element={<CustomerCatalogues />} />
              <Route path="/customer/catalogues/request" element={<CustomerCatalogues />} />
              
              {/* Customer Auth */}
              <Route path="/customer/auth" element={<CustomerAuth />} />
              <Route path="/customer/login" element={<CustomerAuth />} />
              <Route path="/customer/signup" element={<CustomerSignup />} />
              
              {/* Customer Portal Routes (Protected by CustomerLayout) */}
              <Route path="/customer" element={<CustomerLayout />}>
                <Route index element={<CustomerDashboard />} />
                <Route path="dashboard" element={<CustomerDashboard />} />
                <Route path="account" element={<CustomerAccount />} />
                <Route path="orders" element={<CustomerOrders />} />
                <Route path="orders/:orderId" element={<CustomerOrderDetail />} />
                <Route path="orders/:orderId/amend" element={<CustomerAmendOrder />} />
                <Route path="orders/view/:orderId" element={<CustomerOrderView />} />
                <Route path="new-order" element={<CustomerNewOrder />} />
                <Route path="cart" element={<CustomerCart />} />
                <Route path="checkout" element={<CustomerCheckout />} />
                <Route path="order-confirmation" element={<CustomerOrderConfirmation />} />
                <Route path="invoices" element={<CustomerInvoices />} />
                <Route path="invoices/:invoiceId/pay" element={<CustomerPayInvoice />} />
                <Route path="products" element={<CustomerProducts />} />
                <Route path="brands" element={<CustomerBrands />} />
                <Route path="brand/:brandId" element={<CustomerProducts />} />
                <Route path="board" element={<CustomerBoard />} />
                <Route path="catalogues/request" element={<CustomerRequestCatalogue />} />
                <Route path="settings" element={<CustomerSettings />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </MessagingProvider>
    </UserProvider>
  );
}

export default App;